import * as Constants from "../Constants";
import {getAPIIncludeAuth} from './Shared'

export async function getAllVisitLocations() {
    const api = Constants.BACKEND_URL + Constants.API_VISIT_LOCATION + "?paginationEnabled=false";
    return getAPIIncludeAuth(api);
}
